<section class="portal-booking">
  <div class="portal-booking__background"></div>

  <div class="portal-booking__shell">
    <header class="portal-booking__topbar">
      <a class="portal-booking__brand" [href]="'/'" aria-label="Virtualcenter">
        <img
          src="assets/images/branding/virtualcenter-logo-horizontal-negro.png"
          alt="Virtualcenter"
          class="portal-booking__brand-logo"
        />
        <div class="portal-booking__brand-copy">
          <span>Reserva online</span>
        </div>
      </a>
    </header>

    <main class="portal-booking__content">
      <div class="portal-booking__workspace" [class.portal-booking__workspace--done]="step === 'done'">
        <aside class="portal-booking__intro" *ngIf="bootstrap && !portalDisabled && step !== 'done'">
          <section class="portal-booking__intro-card">
            <div class="portal-booking__steps">
              <div class="portal-booking__step" [class.portal-booking__step--active]="step === 'selection'">
                <span>1</span>
                <div>
                  <strong>Tus datos</strong>
                  <small>Identificación y tratamientos</small>
                </div>
              </div>
              <div class="portal-booking__step" [class.portal-booking__step--active]="step === 'schedule'">
                <span>2</span>
                <div>
                  <strong>Agenda</strong>
                  <small>Fecha, hora y profesional</small>
                </div>
              </div>
              <div class="portal-booking__step" [class.portal-booking__step--active]="step === 'review'">
                <span>3</span>
                <div>
                  <strong>Confirmación</strong>
                  <small>Revisión final de la reserva</small>
                </div>
              </div>
            </div>
          </section>
        </aside>

        <div class="portal-booking__main">
          <section class="portal-booking__panel" *ngIf="loading">
            <p>{{ 'COMMON.LOADING' | translate }}</p>
          </section>

          <section
            class="portal-booking__panel portal-booking__panel--state"
            *ngIf="!loading && portalDisabled"
          >
            <h2>Reservas no disponibles</h2>
            <p>Este centro no tiene activa la reserva online en este momento.</p>
          </section>

          <section
            class="portal-booking__panel portal-booking__panel--selection"
            *ngIf="!loading && !portalDisabled && step === 'selection'"
          >
            <div class="portal-booking__panel-head">
              <h2>Reserva tu cita en {{ bootstrap?.site?.name }}</h2>
              <p>Completa tus datos y elige uno o varios tratamientos.</p>
            </div>

            <div class="portal-booking__grid portal-booking__grid--profile">
              <label>
                Nombre
                <input type="text" [(ngModel)]="patient.name" />
              </label>
              <label>
                Apellidos
                <input type="text" [(ngModel)]="patient.surname" />
              </label>
              <label>
                Email
                <input type="email" [(ngModel)]="patient.email" />
              </label>
              <label>
                Teléfono
                <input type="text" [(ngModel)]="patient.phone" />
              </label>
            </div>

            <div class="portal-booking__panel-head portal-booking__panel-head--spaced">
              <h3>Tratamientos</h3>
              <p>Selecciona los servicios que quieres reservar en esta cita.</p>
            </div>

            <div class="portal-booking__treatments" *ngIf="treatments.length; else noTreatments">
              <button
                type="button"
                class="portal-booking__treatment"
                [class.portal-booking__treatment--selected]="selectedTreatmentIds.includes(treatment.id)"
                *ngFor="let treatment of treatments"
                (click)="toggleTreatment(treatment)"
              >
                <div class="portal-booking__treatment-header">
                  <div>
                    <div class="portal-booking__treatment-name">{{ treatment.name }}</div>
                    <div class="portal-booking__treatment-description" *ngIf="treatment.description">
                      {{ treatment.description }}
                    </div>
                  </div>
                  <span class="portal-booking__check">
                    {{ selectedTreatmentIds.includes(treatment.id) ? '✓' : '+' }}
                  </span>
                </div>
                <div class="portal-booking__treatment-meta">
                  <span>{{ treatment.duration_minutes }} min</span>
                  <span>{{ formatPrice(treatment.price) }}</span>
                </div>
              </button>
            </div>

            <ng-template #noTreatments>
              <div class="portal-booking__empty">No hay tratamientos disponibles para reservar online.</div>
            </ng-template>

            <footer class="portal-booking__actions portal-booking__actions--selection">
              <button type="button" class="portal-booking__button" (click)="continueToSchedule()">
                Continuar a agenda
              </button>
            </footer>

            <p class="portal-booking__error" *ngIf="selectionValidationAttempted && submitErrorKey">
              {{ submitErrorKey }}
            </p>
          </section>

          <section class="portal-booking__panel" *ngIf="!loading && !portalDisabled && step === 'schedule'">
            <div class="portal-booking__panel-head">
              <h2>Selecciona fecha y hora</h2>
              <p>
                Reserva {{ scheduleIndex + 1 }} de {{ selectedTreatments.length }}. Elige un día y
                luego una hora disponible.
              </p>
            </div>

            <div class="portal-booking__current" *ngIf="currentTreatment">
              <div class="portal-booking__current-copy">
                <strong>{{ currentTreatment.name }}</strong>
                <span>{{ currentTreatment.duration_minutes }} min · {{ formatPrice(currentTreatment.price) }}</span>
              </div>
              <span class="portal-booking__counter">{{ scheduleIndex + 1 }}/{{ selectedTreatments.length }}</span>
            </div>

            <div class="portal-booking__calendar-layout">
              <section class="portal-booking__calendar-panel">
                <div class="portal-booking__calendar-header">
                  <button
                    type="button"
                    class="portal-booking__button portal-booking__button--ghost"
                    [disabled]="!canGoToPreviousMonth"
                    (click)="previousMonth()"
                  >
                    ‹
                  </button>
                  <strong>{{ monthLabel }}</strong>
                  <button
                    type="button"
                    class="portal-booking__button portal-booking__button--ghost"
                    [disabled]="!canGoToNextMonth"
                    (click)="nextMonth()"
                  >
                    ›
                  </button>
                </div>

                <div class="portal-booking__calendar-weekdays">
                  <span>Lun</span>
                  <span>Mar</span>
                  <span>Mié</span>
                  <span>Jue</span>
                  <span>Vie</span>
                  <span>Sáb</span>
                  <span>Dom</span>
                </div>

                <div class="portal-booking__calendar-grid">
                  <button
                    type="button"
                    class="portal-booking__calendar-day"
                    *ngFor="let cell of calendarCells"
                    [disabled]="!cell.available"
                    [class.portal-booking__calendar-day--ghost]="!cell.currentMonth"
                    [class.portal-booking__calendar-day--available]="cell.available"
                    [class.portal-booking__calendar-day--selected]="cell.selected"
                    (click)="selectCalendarDay(cell.key)"
                  >
                    {{ cell.label }}
                  </button>
                </div>
              </section>

              <section class="portal-booking__slots-panel">
                <div class="portal-booking__panel-head">
                  <h3>Horas disponibles</h3>
                  <p *ngIf="selectedDayKey; else pickDayFirst">
                    {{ selectedDayLabel }}
                  </p>
                  <ng-template #pickDayFirst>
                    <p>Selecciona primero un día con disponibilidad.</p>
                  </ng-template>
                </div>

                <div class="portal-booking__slots" *ngIf="selectedDayKey; else noSelectedDay">
                  <button
                    type="button"
                    *ngFor="let slot of availableSlots"
                    class="portal-booking__slot-button"
                    [class.portal-booking__slot--active]="selectedScheduleSlot?.start_utc === slot.start_utc && selectedScheduleSlot?.end_utc === slot.end_utc"
                    (click)="selectSlot(slot)"
                  >
                    <span class="portal-booking__slot-time">{{ formatTimeRange(slot) }}</span>
                    <small *ngIf="getSlotAvailabilityLabel(slot)">{{ getSlotAvailabilityLabel(slot) }}</small>
                  </button>
                  <p *ngIf="!availableSlots.length">No hay horas disponibles para este día.</p>
                </div>

                <ng-template #noSelectedDay>
                  <div class="portal-booking__empty">Elige un día disponible en el calendario.</div>
                </ng-template>

                <section class="portal-booking__professionals" *ngIf="usesProfessionalRouting && selectedScheduleSlot">
                  <div class="portal-booking__panel-head portal-booking__panel-head--spaced">
                    <h3>Profesional</h3>
                    <p>
                      Si no eliges ninguno, la clínica asignará uno automáticamente entre los
                      disponibles.
                    </p>
                  </div>

                  <div class="portal-booking__professional-list">
                    <button
                      type="button"
                      class="portal-booking__professional-card portal-booking__professional-card--auto"
                      [class.portal-booking__professional-card--selected]="selectedProfessionalUsersId === null"
                      (click)="selectProfessional(null)"
                    >
                      <span class="portal-booking__professional-avatar portal-booking__professional-avatar--auto">A</span>
                      <span class="portal-booking__professional-copy">
                        <strong>Asignación automática</strong>
                        <small>Se asignará un profesional disponible.</small>
                      </span>
                    </button>

                    <button
                      type="button"
                      class="portal-booking__professional-card"
                      *ngFor="let professional of availableProfessionals"
                      [class.portal-booking__professional-card--selected]="selectedProfessionalUsersId === professional.users_id"
                      (click)="selectProfessional(professional.users_id)"
                    >
                      <span class="portal-booking__professional-avatar">
                        {{ getProfessionalName(professional).slice(0, 2).toUpperCase() }}
                      </span>
                      <span class="portal-booking__professional-copy">
                        <strong>{{ getProfessionalName(professional) }}</strong>
                        <small *ngIf="professional.calendar?.name">{{ professional.calendar?.name }}</small>
                      </span>
                    </button>
                  </div>
                </section>
              </section>
            </div>

            <footer class="portal-booking__actions">
              <button
                type="button"
                class="portal-booking__button portal-booking__button--ghost"
                (click)="goBackToSelection()"
              >
                Atrás
              </button>
              <button type="button" class="portal-booking__button" (click)="confirmSelectedSlot()">
                Confirmar horario
              </button>
            </footer>

            <p class="portal-booking__error" *ngIf="submitErrorKey">
              {{ submitErrorKey }}
            </p>
          </section>

          <section class="portal-booking__panel" *ngIf="!loading && !portalDisabled && step === 'review'">
            <div class="portal-booking__panel-head">
              <h2>Revisión</h2>
              <p>Comprueba la reserva antes de confirmarla.</p>
            </div>

            <div class="portal-booking__summary-row" *ngFor="let row of getSummaryRows()">
              <div>
                <strong>{{ row.treatment.name }}</strong>
                <div>{{ formatPrice(row.treatment.price) }}</div>
              </div>
              <div>
                <div>{{ formatTimeRange(row.slot) }}</div>
                <small *ngIf="row.slot?.professional">{{ getProfessionalName(row.slot?.professional) }}</small>
              </div>
            </div>

            <div *ngIf="shouldShowPayment" class="portal-booking__payment">
              <ng-container *ngIf="hasAvailablePaymentMethods; else noPaymentMethods">
                <label>
                  Método de pago
                  <select [(ngModel)]="paymentMethod">
                    <option [ngValue]="''">Selecciona una opción</option>
                    <option *ngFor="let method of availablePaymentMethods" [ngValue]="method.name">
                      {{ method.display_name || method.name }}
                    </option>
                  </select>
                </label>
                <label class="portal-booking__checkbox">
                  <input type="checkbox" [(ngModel)]="agreeToPay" />
                  Acepto continuar con el pago si es necesario para confirmar la reserva.
                </label>
              </ng-container>

              <ng-template #noPaymentMethods>
                <p class="portal-booking__error">No hay métodos de pago configurados para este centro.</p>
              </ng-template>
            </div>

            <footer class="portal-booking__actions">
              <button
                type="button"
                class="portal-booking__button portal-booking__button--ghost"
                (click)="goBackToSchedule()"
              >
                Atrás
              </button>
              <button
                type="button"
                class="portal-booking__button"
                [disabled]="submitting"
                (click)="submitRequests()"
              >
                Confirmar reserva
              </button>
            </footer>

            <p class="portal-booking__error" *ngIf="submitErrorKey">
              {{ submitErrorKey }}
            </p>
          </section>

          <section class="portal-booking__panel portal-booking__panel--state" *ngIf="step === 'done'">
            <div class="portal-booking__panel-head portal-booking__panel-head--state">
              <h2>Reserva enviada</h2>
              <p>
                Te hemos enviado un email con la referencia y el enlace para cancelar o reprogramar
                cada cita.
              </p>
            </div>
            <p *ngIf="successReference"><strong>{{ successReference }}</strong></p>

            <div class="portal-booking__summary-row" *ngFor="let row of getSummaryRows()">
              <div>
                <strong>{{ row.treatment.name }}</strong>
                <div>{{ formatPrice(row.treatment.price) }}</div>
              </div>
              <div>
                <div>{{ formatTimeRange(row.slot) }}</div>
                <small *ngIf="row.slot?.professional">{{ getProfessionalName(row.slot?.professional) }}</small>
              </div>
            </div>

            <p *ngIf="successManageUrl">
              <a [href]="successManageUrl" class="portal-booking__inline-link">Gestionar esta reserva</a>
            </p>
          </section>
        </div>
      </div>
    </main>

    <footer class="portal-booking__footer">
      <div class="portal-booking__footer-brand">
        <img
          src="assets/images/branding/virtualcenter-isotipo-negro.png"
          alt="Virtualcenter"
          class="portal-booking__footer-logo"
        />
        <span>Powered by Virtualcenter</span>
      </div>
      <div class="portal-booking__footer-copy">
        <span>Gestión de citas y pacientes para clínicas</span>
        <span class="portal-booking__topbar-dot">•</span>
        <a href="mailto:soporte&#64;virtualcenter.com" class="portal-booking__inline-link">
          soporte&#64;virtualcenter.com
        </a>
      </div>
    </footer>
  </div>
</section>
